<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="ibox">
					<div class="ibox-content">
						<div class="row d-flex justify-content-center">
							<div v-if="backup_files">
								<div v-if="hasBackupOwnedBySomeoneElse">
									<p>Másik leltározó által létrehozott fájlok vannak az eszközödön. Kérlek, keress egy
										lelrárvezetőt.</p>
									<div v-for="(file, id) in backup_files" :key="id">
										{{ file }}
									</div>
								</div>
								<div v-else>
									<p class="alert alert-info">Van már megkezdett leltárhelyed. Folytasd vagy zárd le. (A
										lezáráshoz is a folytatás gombra nyomva jutsz el.) </p>
									<div v-for="(file, id) in backup_files" :key="id">
										<div class="row">
											<div class="col-8 align-middle py-2 fs-2">{{ file.split('_')[2].split('.')[0] }}
											</div>
											<div class="col-4 text-center"><button class="btn btn-primary"
													@click="loadBackupFile(file)">Folytatom</button></div>
										</div>
									</div>
								</div>
							</div>
							<div class="w-100" v-else>
								<div class="text-center" v-if="activePlace != null">
									<div class="input-group mb-2">
										<div class="input-group-prepend">
											<button class="btn"
										:class="{ 'btn-primary': data_collection_mode == data_collection_types[0].id, 'btn-white text-muted': data_collection_mode != data_collection_types[0].id }"
										@click="updateDataCollectionModeNew(data_collection_types[0].id)">{{ data_collection_types[0].name }}</button>
										</div>
										<span class="form-control">adatgyűjtési mód</span>
										<div class="input-group-append">
											<button class="btn"
										:class="{ 'btn-primary': data_collection_mode == data_collection_types[1].id, 'btn-white text-muted': data_collection_mode != data_collection_types[1].id }"
										@click="updateDataCollectionModeNew(data_collection_types[1].id)">{{ data_collection_types[1].name }}</button>
										</div>
									</div>
									<span class="text-center bg-success fs-lg mb-2 p-1 b-r-md"> Raktárhely -
										{{ activePlace.barcode }}</span>
									<h5 class="label mb-0 p-1">Vonalkód</h5>
									<form @submit.prevent="checkBarcode">
										<input class="form-control form-control-lg fs-lg text-center" @focus="$event.target.select()"
											ref="barcode_input" type="text" v-model="barcode" :disabled="itemName" />
									</form>
									<div v-if="itemName" class="mt-4">
										<h3 class="bg-muted mb-0 p-1">{{ itemName }}</h3>
										<form @submit.prevent="storeAmountCheck(barcode, amount)">
											<div class="input-group mb-0">
												<div class="input-group-prepend">
													<button type="submit" class="btn btn-primary"><i
															class="fa fa-save"></i></button>
												</div>
												<input type="number" required @focus="$event.target.select()"
													ref="amount_input" class="form-control text-right form-control-lg fs-lg" lang="hu-HU"
													step="0.001" min="0.001" v-model="amount">
												<div class="input-group-append">
													<span class="input-group-addon align-middle">
														<span class="my-auto">db</span>
													</span>
													<button type="button" @click="cancelItem()" class="btn btn-danger"><i
															class="fa fa-times"></i></button>
												</div>
											</div>
											<div class="label label-danger mt-0" v-if="errors.amount">{{ errors.amount[0] }}
											</div>
										</form>

									</div>
									<div v-if="notfound">
										<div class="label label-danger">
											NEM TALÁLHATÓ!
										</div>
										<button @click="openUnknownModal()" class="btn btn-warning btn-xs"><i
												class="fa fa-question-circle"></i> rögzítés ismeretlenként</button>
									</div>
									<button class="btn btn-primary mt-3" v-if="!itemName && activeItems.length != 0"
										@click="finishPlace()">Lezárás <i class="fa fa-lock"></i></button>
									<button v-if="activeItems.length == 0" class="btn btn-danger mt-3"
										@click="closePlace()"><i class="fa fa-times"></i> Mégse</button>
									<div v-if="activeItems.length != 0">
										<hr>
										<h3>Megtalált elemek:</h3>
										<table class="table table-striped w-100">
											<tr v-for="(item, key) in (activeItems.slice().reverse())" :key="key"
												:ref="activeItems.indexOf(item) + '_row'">
												<td>{{ activeItems.indexOf(item) + 1 }}</td>
												<td>
													<p class="m-0">{{ item.name }}</p>
													<p class="m-0">{{ item.barcode }}</p>
												</td>
												<td class="text-dark table-input-wide pl-0">
													<form @submit.prevent="validateAmount(item, 1)">
														<div class="input-group table-input-wide">
															<input type="number"
																:ref="activeItems.indexOf(item) + '_amount_input_no_form'"
																@focus="$event.target.select()"
																@blur="validateAmount(item)"
																class="form-control text-right" step="0.001" min="0.001"
																v-model="item.amount">
															<div class="input-group-append">
																<button type="button" class="btn btn-danger" @click="showDelete(item)"><i
																	class="fa fa-trash"></i></button>
															</div>
														</div>
													</form>
												</td>
											</tr>
										</table>
									</div>
								</div>
								<div class="col-md-4 text-center" v-if="activePlace == null">
									<h3 class="text-center">Raktárhely</h3>
									<form @submit.prevent="checkPlace()">
										<input ref="place_barcode_input" class="form-control form-control-lg fs-lg text-center"
											@focus="$event.target.select()" type="text" v-model="place_barcode" />
									</form>
									<div v-if="place_not_found == true" class="label label-danger">
										NEM TALÁLHATÓ!
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="modal">
			<modal-vue modalSize="sm" @on-close="closeUnknownModal()" name="unknown_modal"
				:headerOptions="{ title: 'Rögzítés ismeretlenként' }" :footerOptions="{
					btn1: 'Mégse',
					disableBtn2: true,
					btn1OnClick: () => {
						closeUnknownModal();
					},
				}">
				<div class="row d-flex justify-content-center" v-if="supervisor_access == false">
					<div class="col-10 text-center">
						<h3>Adja meg a supervisori jelszót</h3>
						<form @submit.prevent="checkSupervisorPass($event)">
							<input v-model="form_pass" type="password" class="form-control text-center" inputmode="numeric">
							<div class="label label-danger" v-if="errors.form_pass">{{ errors.form_pass[0] }}</div>
							<button type="submit" class="btn btn-primary mt-2"><i class="fa fa-key"></i> Feloldás</button>
						</form>
					</div>
				</div>
				<div class="row d-flex justify-content-center" v-else>
					<div class="col-10 text-center">
						<span class="label label-success">{{ barcode }}</span>
						<h5 class="label mb-0 p-2">Adja meg a mennyiséget:</h5>
						<form @submit.prevent="supervisorSubmit()">
							<div class="input-group">
								<input v-model="amount" type="number" class="form-control text-right" inputmode="decimal"
									min="0">
								<div class="input-group-append">
									<span class="input-group-addon">db</span>
								</div>
							</div>
							<div class="label label-danger" v-if="errors.amount">{{ errors.amount[0] }}</div>
							<button type="submit" class="btn btn-primary mt-2"><i class="fa fa-save"></i> Rögzítés</button>
						</form>
					</div>
				</div>
			</modal-vue>
		</div>
		<div id="supervisor_modal">
			<modal-vue modalSize="sm" @on-close="closeSupervisorModal()" name="supervisor_modal"
				:headerOptions="{ title: 'Ismételt rögzítés' }" :footerOptions="{
					btn1: 'Mégse',
					btn2: 'Felold',
					btn1OnClick: () => {
						closeSupervisorModal();
					},
					btn2OnClick: () => {
						simpleSupervisorCheck();
					},
				}">
				<div class="col-10 text-center mx-auto">
					<h3>Adja meg a supervisori jelszót</h3>
					<form @submit.prevent="simpleSupervisorCheck()">
						<input v-model="form_pass" type="password" class="form-control text-center" inputmode="numeric">
						<div class="label label-danger" v-if="errors.form_pass">{{ errors.form_pass[0] }}</div>
					</form>
				</div>
			</modal-vue>
		</div>
	</div>
</template>

<script>
import appService from '../../apis/appService.js';
import Barcode from '../../apis/Barcode.js';
import moment from 'moment'

export default {
	name: 'tc26',
	data() {
		return {
			errors: [],
			barcode: null,
			place_found: false,
			place_barcode: null,
			itemName: false,
			notfound: false,
			place_not_found: false,
			amount: null,
			data_collection_mode: 1,
			supervisor_access: false,
			form_pass: null,
			correct_barcode_sound: require('../../assets/sounds/ES_Multimedia_781.mp3'),
			wrong_barcode_sound: require('../../assets/sounds/ES_MM_Error_23.mp3'),
			correct_amount: require('../../assets/sounds/select-click-1109.wav'),
			wrong_amount: require('../../assets/sounds/click-error-1110.wav'),
			activeItems: [],
			backup_files: false
		}
	},
	computed: {
		count_type() {
			return this.$store.state.count_type;
		},
		activePlace() {
			return this.$store.state.activePlace;
		},
		lszsz() {
			return this.$store.state.lszsz;
		},
		data_collection_types() {
			return this.$store.state.data_collection_types;
		},
		supervisor_code() {
			return this.$store.state.supervisor_code;
		},
		user() {
			return this.$store.state.user;
		},
		place_statuses() {
			return this.$store.state.place_statuses;
		},
		hasBackupOwnedBySomeoneElse() {
			let ownedBySomeoneElse = false;
			if (this.backup_files) {
				let lszsz = this.lszsz;
				this.backup_files.forEach(function (file) {
					var parts = file.split('_');
					if (lszsz !== parts[1]) {
						ownedBySomeoneElse = true;
					}
				})
			}
			return ownedBySomeoneElse;
		}
	},
	mounted() {
		this.$refs.place_barcode_input.focus();
	},
	created() {
		this.$store.commit('updateSubTitle', 'Adatgyűjtés');

		let response = appService.getBackupFiles(this.user.project_id);
		if (response.length > 0) {
			this.backup_files = response.split(',');
		}

		//frissítsük be a tempot
		appService.getTempo(this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
			this.$store.commit('updateUser', { ...this.user, tempo: response.data });
		});

	},


	methods: {
		checkPlaceBarcodeAndTransform() {
			if (this.place_barcode.length == 20) {
				let clean = this.place_barcode.substr(11, 8)
				this.place_barcode = clean.substr(0, 1) + '-' + clean.substr(1, 3) + '-' + clean.substr(4, 2) + '-' + clean.substr(6, 2);
			}
		},
		cancelItem() {
			new Promise(resolve => {
				this.itemName = false;
				this.barcode = null;
				resolve('finished');
			}).then(() => {
				this.$refs.barcode_input.focus();
			})
		},
		storeAmountCheck(barcode, amount) {
			if (String(amount).charAt(0) == ',' || String(amount).charAt(0) == '.') {
				this.$set(this.errors, 'amount', ['csak számmal kezdődhet!']);
			} else {
				this.errors = [];
				let confirm_message = null;
				if (this.activeItems.length != 0 && this.activeItems.at(-1).barcode == barcode && this.activeItems.at(-1).amount == amount) {
					confirm_message = 'A legutóbbi ugyanez a vonalkód és mennyiség volt! Biztos rögzíted?';
				} else if (amount > 100) {
					confirm_message = 'A rögzíteni kívánt mennyiség: ' + amount + ' nagyobb mint 100, biztos rögzíti?'
				}
				if (confirm_message != null) {
					this.$confirm({
						message: confirm_message,
						button: {
							no: 'Nem',
							yes: 'Igen',
						},
						callback: confirm => {
							if (confirm) {
								this.storeAmount(barcode, amount);
							}
						}
					});
				} else {
					this.storeAmount(barcode, amount)
				}
			}
		},
		showDelete(item) {
			this.$confirm({
				message: 'biztos törlöd ezt: ' + item.name + ' ' + item.amount + 'db?',
				button: {
					no: 'Nem',
					yes: 'Igen',
				},
				callback: confirm => {
					if (confirm) {
						this.activeItems.splice(this.activeItems.indexOf(item), 1);
					}
				}
			});
		},
		countDecimals(amount) {
			if (Math.floor(amount) === parseFloat(amount)) {
				return 0;
			} else {
				return amount.toString().split(".")[1].length;
			}
		},
		validateAmount(item, confirm_off = null) {
			let error = null
			if (!item.amount || item.amount == null) {
				error = 'adj meg egy számot!'
			} else if (this.countDecimals(item.amount) > 3) {
				error = '3 tizedesig adhatja meg a mennyiséget'
			} else if (item.amount > 9999) {
				error = 'max 9999 lehet!'
			} else if (item.amount < 0.001) {
				error = 'min 0.001 lehet!'
			} else if (String(item.amount).charAt(0) == ',' || String(item.amount).charAt(0) == '.') {
				error = 'csak számmal kezdődhet!'
			}
			if (error != null) {
				appService.playAndroidSound('wrong_amount');
				this.$refs[this.activeItems.indexOf(item) + '_amount_input_no_form'][0].focus();
				this.$toast.open({
					message: error,
					type: 'error',
					position: 'top',
				});
				return 0;
			} else if (confirm_off != 1 && item.amount > 100) {
				this.$confirm({
					message: 'A rögzíteni kívánt mennyiség: ' + item.amount + ' nagyobb mint 100, biztos rögzíti?',
					button: {
						no: 'Nem',
						yes: 'Igen',
					},
					callback: confirm => {
						if (confirm) {
							this.$refs[this.activeItems.indexOf(item) + '_amount_input_no_form'][0].blur();
							return 1;
						} else {
							this.$refs[this.activeItems.indexOf(item) + '_amount_input_no_form'][0].focus();
							return 0;
						}
					}
				});
			} else {
				this.$refs[this.activeItems.indexOf(item) + '_amount_input_no_form'][0].blur();
				return 1;
			}
		},
		closePlace() {
			let vue = this;
			new Promise(function (resolve) {
				vue.place_found = false;
				vue.place_not_found = false;
				vue.place_barcode = null;
				vue.$store.commit('updateActivePlace', null);
				vue.activeItems = [];
				resolve('finished')
			}).then(() => {
				this.$refs.place_barcode_input.focus();
			});
		},
		supervisorSubmit() {
			let vue = this;
			new Promise(function (resolve) {
				vue.storeAmount(vue.barcode, vue.amount);
				resolve('finished');
			}).then(() => {
				this.amount = null;
				this.closeUnknownModal();
			});
		},
		checkSupervisorPass() {
			if (this.form_pass == this.supervisor_code) {
				this.supervisor_access = true;
				this.errors = [];
			} else {
				this.$set(this.errors, 'form_pass', ['helytelen jelszó']);
			}
		},
		simpleSupervisorCheck() {
			if (this.form_pass == this.supervisor_code) {
				this.errors = [];
				this.closeSupervisorModal();
				this.checkPlace(1);
			} else {
				this.$set(this.errors, 'form_pass', ['helytelen jelszó']);
			}
		},
		closeUnknownModal() {
			this.$vm2.close('unknown_modal');
			this.supervisor_access = false;
			this.form_pass = null;
		},
		closeSupervisorModal() {
			this.$vm2.close('supervisor_modal');
			this.supervisor_access = false;
			this.form_pass = null;
			this.$refs.place_barcode_input.focus();
		},
		openUnknownModal() {
			this.$vm2.open('unknown_modal');
		},
		openSupervisorModal() {
			this.$vm2.open('supervisor_modal');
		},
		/*updateDataCollectionMode(){
			this.$store.commit('updateDataCollectionMode',this.data_collection_mode);
		},*/ //akkor használtuk amikor select volt v-model a data_collection_modera
		updateDataCollectionModeNew(mode) {
			this.$set(this, 'data_collection_mode', mode);
			this.$store.commit('updateDataCollectionMode', mode);
			this.$refs.barcode_input.focus();
		},
		checkBarcode() {
			switch (this.count_type){
				case 2://obi
					this.barcode = Barcode.obiBarcodeSlice(this.barcode);
				break;
				case 3://hervis
				this.barcode = Barcode.hervisBarcodeSlice(this.barcode);
				break;
				default:
					this.barcode = Barcode.regularBarcodeSlice(this.barcode);
			}
			this.$refs.barcode_input.blur();
			let itemName = appService.checkBarcode(this.barcode);
			if (itemName) {
				appService.playAndroidSound('correct_barcode');
				if (this.data_collection_mode == 1) {
					let vue = this;
					new Promise(function (resolve) {
						vue.notfound = false;
						vue.itemName = itemName;
						resolve('finished')
					}).then(() => {
						this.$refs.amount_input.focus();
					});
				}
				else {
					this.notfound = false;
					this.storeAmount(this.barcode, 1, itemName);
				}
			}
			else {
				appService.playAndroidSound('wrong_barcode');
				this.notfound = true;
				this.itemName = false;
				this.$refs.barcode_input.focus();
			}
		},
		checkPlace(found_value) {
			this.place_barcode = Barcode.placeBarcodeSlice(this.place_barcode);
			let found = 0;//rakátrhely státusza kerül ide
			if (typeof found_value == 'undefined') {
				found = appService.checkPlace(this.place_barcode);
			} else {
				found = found_value;
			}
			this.$refs.place_barcode_input.blur();
			if (found < 5 && found != 0 && typeof found != 'undefined') {
				appService.playAndroidSound('correct_barcode');
				let vue = this;
				new Promise(function (resolve) {
					vue.place_found = true;
					vue.place_not_found = false;
					vue.$store.commit('updateActivePlace', { barcode: vue.place_barcode, start_stamp: moment().format('YYYY-MM-DD HH:mm:ss') });
					vue.activeItems = [];
					resolve('finished')
				}).then(() => {
					this.$refs.barcode_input.focus();
					//document.getElementById('navbarNav').collapse();
				});
			}
			else if (found == 0 || typeof found == 'undefined') {
				appService.playAndroidSound('wrong_barcode');
				this.place_found = false;
				this.place_not_found = true;
				this.$store.commit('updateActivePlace', null);
				this.$refs.place_barcode_input.focus();
			} else {
				this.$confirm({
					message: 'Ez a leltárhely "' + this.place_statuses[this.place_statuses.map(status => status.id).indexOf(found)].name + '" állapotú, biztos rögzíted mégegyszer?',
					button: {
						no: 'Nem',
						yes: 'Igen',
					},
					callback: confirm => {
						if (confirm) {
							this.openSupervisorModal();
						} else {
							this.$refs.place_barcode_input.focus();
						}
					}
				});
			}
		},

		storeAmount(barcode, amount, itemName = null) {
			if (amount >= 9999) {
				this.$refs.amount_input.blur();
				appService.playAndroidSound('wrong_amount');
				this.$set(this.errors, 'amount', ['max 9999-et adhat meg']);
				this.$refs.amount_input.focus();
			} else {
				this.errors = [];
				appService.playAndroidSound('correct_amount');

				if (itemName == null) {
					if (this.itemName == false) {
						itemName = 'ismeretlen';
					} else {
						itemName = this.itemName;
					}
				}

				let currentdate = moment().format('YYYY-MM-DD HH:mm:ss');

				//lementjük az androidra, hogy vissza tudjuk tölteni,ha lemerül
				let response = appService.storeBackup(
					this.user.project_id,
					this.lszsz,
					this.activePlace.barcode,
					barcode,
					parseFloat(amount),
					currentdate,
					itemName
				);

				if (response == true) {
					let vue = this;
					new Promise(function (resolve) {

						let item = { barcode: barcode, amount: amount, timestamp: currentdate, name: itemName };

						vue.activeItems.push(item);
						vue.amount = null;

						resolve('finished');
					}).then(() => {
						let vue = this;
						new Promise(resolve => {
							vue.itemName = false;
							vue.barcode = null;
							resolve('finished');
						}).then(() => {
							this.$refs.barcode_input.focus();
						});
						this.$toast.success('mennyiség sikeresen mentve!', {
							position: 'top'
						});
					})
				}
			}
		},
		finishPlace() {
			let vue = this;
			new Promise((resolve) => {
				this.activeItems.forEach(item => {
					if (this.validateAmount(item, 1) == 0) {
						throw vue.activeItems.indexOf(item);
					}
				});
				resolve('finished');
			}).then(() => {
				this.$confirm({
					title: `Biztos lezárod ezt a raktárhelyet?`,
					message:'Össz tétel: '+this.activeItems.length+' Mennyiség: '+this.activeItems.reduce((a,b) => {
						return a+parseInt(b.amount);
					},0),
					button: {
						no: 'Nem',
						yes: 'Igen'
					},
					/**
					* Callback Function
					* @param {Boolean} confirm
					*/
					callback: confirm => {
						if (confirm) {
							let vue = this;
							new Promise(function (resolve) {
								vue.activeItems.forEach(item => {
									appService.storeAmount(item.barcode, parseFloat(item.amount), '', '', item.timestamp);
								})
								resolve('finished')
							}).then(() => {
								let finished = appService.finishPlace(this.user.project_id, this.lszsz, this.activePlace.barcode, appService.getDeviceId(), this.activePlace.start_stamp);

								if (finished === "1") {
									let vue = this;
									new Promise(function (resolve) {
										vue.place_found = false;
										vue.place_not_found = false;
										vue.place_barcode = null;
										vue.$store.commit('updateActivePlace', null);
										vue.activeItems = [];
										resolve('finished')
									}).then(() => {
										this.$refs.place_barcode_input.focus();
									});
								}
								else {
									this.$toast.open({
										message: finished,
										position: 'top',
										type: 'error'
									});
								}
							})

						}
					}
				});
			}).catch(e => {
				this.$refs[e + '_row'][0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
			});
		},
		loadBackupFile(filename) {
			let response = JSON.parse(appService.loadBackupFile(filename));

			let vue = this;
			response.items.forEach(function (item) {
				vue.activeItems.push(item);
			});

			this.place_barcode = response.lth;
			this.place_found = true;
			this.place_not_found = false;
			this.backup_files = false;
			vue.$store.commit('updateActivePlace', { barcode: this.place_barcode, start_stamp: moment().format('YYYY-MM-DD HH:mm:ss') });
		}
	},
}
</script>

<style></style>